module.exports = __webpack_public_path__ + "img/MGH-Gaien-6.aec31016.jpg";